/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Move_Line_DownInputs */



/**
* | output |
* | --- |
* | "Move Line Down" |
*
* @param {Shortcut_Keys_Name_Move_Line_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_move_line_down = /** @type {((inputs?: Shortcut_Keys_Name_Move_Line_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Move_Line_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer une ligne vers le bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Linie nach unten verschieben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la linea verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвинуть линию вниз")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover línea hacia abajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向下移动线路")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行を下に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइन को नीचे ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Deslizar a linha para baixo")
	return /** @type {LocalizedString} */ ("Move Line Down")
});